var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup_in"},[_c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup_close_blue"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('CloseBlue')],1)]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"title"},[_vm._v("הפרטים נשלחו בהצלחה")])])
}]

export { render, staticRenderFns }